(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', ()=>this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }

      // Idle warmup for HTML5 <video> only (skip iframes) to improve first play without blocking main thread.
      this.scheduleHtml5VideoWarmup();
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState("play")
      if (!this.videoContainer) {
        this.appendChild(this.template?.content.cloneNode(true));
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach(video => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (
              video.duration &&
              video.currentTime >= video.duration &&
              this.loop == 'false'
            ) {
              this.pauseVideo();
              this.switcherVideoButtonState("pause");
            }
          });
        });
      }

      
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState("pause")
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach(video => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState (state = "play") {
      if (state == "pause") {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == "play") {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Schedule work in idle time to avoid competing with main thread.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 1200);
      }
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
